import { render } from "./PayrollCon.vue?vue&type=template&id=32c9acf4&ts=true"
import script from "./PayrollCon.vue?vue&type=script&lang=ts"
export * from "./PayrollCon.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\a\\1\\s\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__